import React from "react";
import PropTypes from "prop-types";
import { TrackingClient } from "@sparefoot/tracking-client";
import { trackCTAClick } from "hooks/tracking/utils/clickTrackingUtils";
import { H2, Paragraph } from "../../core/Typography";
import UnitCard from "./UnitCard";

const UnitsList = ({
	units,
	title,
	closures,
	facilityId,
	facilityName,
	location,
	nearbyFacilitiesUrl,
	handleCreateBooking,
	handleBookingDetails,
	adminFee,
	lockFee,
	showFeeWarning,
	totalFees,
	cityUrl
}) => {
	if (!units.length) return null;
	const [expandedUnit, setExpandedUnit] = React.useState(null);

	const handleToggleUnitDrawer = (unit) => (id) => {
		if (!expandedUnit) {
			TrackingClient.trackFacilityUnitSelected({
				facility: {
					id: unit?.facilityId,
					name: facilityName,
					location: location?.zip
				},
				last_unit_added_date: new Date(),
				unit: {
					currency: "usd",
					id: unit?.id,
					variant_size: unit?.sizeText,
					price: unit?.lowestPrice,
					quantity: 1
				},
				unit_id: unit?.id,
				unit_promo: unit?.special
			});
			trackCTAClick(
				"render-reservation-form-button",
				"Continue Now Button",
				"Reserve Now",
				cityUrl
			);
		}
		setExpandedUnit(expandedUnit === id ? null : id);
	};

	return (
		<div className="units-list">
			<H2
				mediumSize="standard"
				size="large"
				last
			>
				{title}
			</H2>
			<Paragraph
				last
				size="tiny"
			>
				*Prices are subject to change based on availability
			</Paragraph>
			{showFeeWarning && totalFees > 0 && (
				<Paragraph
					last
					size="small"
					weight="medium"
					className="fees-info-banner"
				>
					Select a unit to see full pricing with additional fees
					displayed.
				</Paragraph>
			)}
			<div className="unit-cards">
				{units.map((u) => (
					<UnitCard
						key={u.id}
						handleToggleDrawer={handleToggleUnitDrawer(u)}
						drawerExpanded={expandedUnit === u.id}
						closures={closures}
						facilityId={facilityId}
						nearbyFacilitiesUrl={nearbyFacilitiesUrl}
						handleCreateBooking={handleCreateBooking}
						handleBookingDetails={handleBookingDetails}
						adminFee={adminFee}
						lockFee={lockFee}
						showFeeWarning={showFeeWarning}
						totalFees={totalFees}
						cityUrl={cityUrl}
						{...u}
					/>
				))}
			</div>
		</div>
	);
};

UnitsList.propTypes = {
	title: PropTypes.string,
	units: PropTypes.arrayOf(PropTypes.shape(UnitCard.propTypes)).isRequired,
	closures: PropTypes.arrayOf(PropTypes.string),
	facilityId: PropTypes.number,
	facilityName: PropTypes.string,
	location: PropTypes.object,
	nearbyFacilitiesUrl: PropTypes.string,
	handleCreateBooking: PropTypes.func,
	handleBookingDetails: PropTypes.func,
	adminFee: PropTypes.number,
	lockFee: PropTypes.number,
	showFeeWarning: PropTypes.bool,
	totalFees: PropTypes.number,
	cityUrl: PropTypes.string
};

export default UnitsList;
